export const AssignmentStatus = Object.freeze({
    Pending: 1,
    Accepted: 2,
    Rejected: 3,
    Cancelled: 4,
})

export const CourseApplicationStatus = Object.freeze({
    Pending: 1,
    Accepted: 2,
    Rejected: 3,
    Cancelled: 4,
})

export const CourseRecordStatus = Object.freeze({
    Pending: 1,
    Attended: 2,
    Absent: 3,
    Cancelled: 4,
})

export const CourseParticipationStatus = Object.freeze({
    None: 1,
    Pending: 2,
    Upcoming: 3,
    Current: 4,
    Completed: 5,
})

export const CourseSessionType = Object.freeze({
    F2F : 'F2F',
    Zoom: 'Zoom',
    Elearning: 'Elearning'
})

export const AwardedFor = Object.freeze({
    SessionGroup: 'App\\Models\\CourseSessionGroup'
})

export const CourseTypes = Object.freeze({
    1: 'Educator Led',
    2: 'E-Learning'
})
